var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-type-icon"},[_c('i',{class:[_vm.statusClass, _vm.statusIcon]})])
}
var staticRenderFns = []

export { render, staticRenderFns }